import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const shipmentReportApi = createApi({
  reducerPath: 'shipmentReportApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['template'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getTemplates: builder.query({
      query: ({ subject }) => ({
        method: 'GET',
        path: `Template/GetTemplates/${subject}`,
      }),
      providesTags: ['template'],
    }),
    getTemplateFields: builder.query({
      query: ({ subject }) => ({
        method: 'GET',
        path: `Template/fields/${subject}`,
      }),
    }),
    getTemplate: builder.query({
      query: ({ id }) => ({
        method: 'GET',
        path: `Template/${id}`,
      }),
      providesTags: ['template'],
    }),
    updateTemplate: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'PUT',
        path: `Template/${data.id}`,
      }),
      invalidatesTags: ['template'],
    }),
    deleteTemplate: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `Template/${id}`,
      }),
      invalidatesTags: ['template'],
    }),
    getCategories: builder.query({
      query: ({ subject }) => ({
        method: 'GET',
        path: `Template/categories/${subject}`,
      }),
    }),
    createTemplate: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Template',
      }),
      invalidatesTags: ['template'],
    }),
    DownloadUserControlReportExcel: builder.mutation({
      query: ({ data }) => ({
        data,
        download: true,
        headers: { 'Content-Type': 'application/json-patch+json' },
        extension: 'xlsx',
        method: 'POST',
        path: 'Reports/DownloadUserControlReportExcel',
      }),
    }),
    DownloadShipmentExcel: builder.mutation({
      query: ({ data }) => ({
        data,
        download: true,
        headers: { 'Content-Type': 'application/json-patch+json' },
        extension: 'xlsx',
        method: 'POST',
        path: 'Reports/DownloadShipmentExcel',
      }),
    }),
    getConsignors: builder.query({
      query: ({ searchText }) => ({
        method: 'GET',
        path: `Reports/ConsignorNameFilter/${searchText}`,
      }),
    }),
    getConsignees: builder.query({
      query: ({ searchText }) => ({
        method: 'GET',
        path: `Reports/ConsigneeNameFilter/${searchText}`,
      }),
    }),
    getServices: builder.query({
      query: () => ({
        method: 'GET',
        path: 'Services',
      }),
    }),
    filterShipmentReport: builder.query({
      query: ({ filter }) => ({
        method: 'GET',
        path: `Reports/NewShipmentReport/${filter}`,
      }),
    }),
    filterUserControlReport: builder.query({
      query: ({ filter }) => ({
        method: 'GET',
        path: `Reports/NewUserControlReport/${filter}`,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const shipmentReportApiReducerName = shipmentReportApi.reducerPath;
export const shipmentReportApiReducer = shipmentReportApi.reducer;
export const shipmentReportApiMiddleware = shipmentReportApi.middleware;

export const {
  useGetTemplatesQuery,
  useCreateTemplateMutation,
  useGetTemplateFieldsQuery,
  useGetCategoriesQuery,
  useGetTemplateQuery,
  useUpdateTemplateMutation,
  useDeleteTemplateMutation,
  useGetServicesQuery,
  useGetConsignorsQuery,
  useGetConsigneesQuery,
  useLazyFilterShipmentReportQuery,
  useLazyFilterUserControlReportQuery,
  useDownloadUserControlReportExcelMutation,
  useDownloadShipmentExcelMutation,
} = shipmentReportApi;
